module.exports = __webpack_public_path__ + "static/media/debug.mono.bad973bc.frag";